/**
 * tutorLane — is the tutor lane in this build at all?
 *
 * WHY (Imdad, 2026-10-16): a tutor types bank details, sort code and account
 * number, for Wise payouts on /tutors/dashboard (views/teach/TeachDashboard.vue,
 * api/teacher/payout-recipient.ts). If the store app could open that page,
 * Google Play's Data safety form would have to declare that the app collects
 * payment info. So inside a native shell the whole lane is unreachable:
 * /tutors, everything under it, and the /teach redirects that lead there. On
 * the web nothing changes.
 *
 * One question, asked by the router (a guard and the breadcrumb that computes
 * a tutor's way home) and by every link into the lane. Derived from the
 * platform seam and nothing else, like paymentRoute.ts, so it is not a second
 * door: it asks platform/capabilities for the shell.
 */
import { isNativeShell } from './capabilities'

/** The lane's addresses: the sign-up door, the dashboard under it, and the old /teach names. */
const TUTOR_LANE_PREFIXES = ['/tutors', '/teach']

/** Can this build open the tutor lane? False inside a native shell. */
export function tutorLaneAvailable(): boolean {
  return !isNativeShell()
}

/**
 * Is this path in the tutor lane? /teacher-insights is not: the prefix must be
 * the whole path or followed by a slash. Vue Router matches case-insensitively,
 * so /TUTORS is the lane too.
 */
export function isTutorLanePath(path: string): boolean {
  const lower = path.toLowerCase()
  return TUTOR_LANE_PREFIXES.some((p) => lower === p || lower.startsWith(`${p}/`))
}

/** A tutor-lane path this build must not open. The router sends it to the learner home. */
export function isClosedTutorLanePath(path: string): boolean {
  return !tutorLaneAvailable() && isTutorLanePath(path)
}
